import axios from "axios";
import { getRoles } from "../helpers/authHelper";

export interface Fisher {
  userID: string;
  userName: string;
  firstName: string;
  lastName: string;
  middleName: string;
  displayName: string;
  email: string;
  phone: string;
  lastLogin: string;
  profile: {
    biaNumber: number;
    organizationCodeNumber: string;
  };
  commercialLicense: string;
  commercialActive: boolean;
  commercialActiveDate: string;
  commercialExpireDate: string;
  subsistenceLicense: string;
  status: string;
  licenseStatus: string;
}

export const listOrganizationFishers = async (OrgID: number) => {
  try {
    let endpoint = "";
    if (getRoles().includes("CORA_Admin"))
      endpoint = `${process.env.REACT_APP_API}/User/list-organization-fishers?OrganizationID=${OrgID}`;
    else endpoint = `${process.env.REACT_APP_API}/User/list-fishers`;

    const response = await axios.get(endpoint);

    return response.data;
  } catch (error) {
    console.error(error);
    const result: string[] = [];
    return result;
  }
};
